import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FnolRequest, fnolRequestExample} from "../../../models";
import {jsPDF} from 'jspdf';
import { DatePipe } from '@angular/common';
import { generateFnolSummaryPDF } from "../../../helpers/utility";

@Component({
  selector: 'CPF-fnol-details-preview',
  templateUrl: './fnol-details-preview.component.html',
  styleUrls: ['./fnol-details-preview.component.scss']
})

export class FnolDetailsPreviewComponent {
  @Input()
  public fnolRequest: FnolRequest | undefined = fnolRequestExample;

  @Output()
  searchContract = new EventEmitter<{ fieldName: string, value: string }[]>();

  expanded: boolean = true;
  base64Doc: string | null = null;

  constructor(private datePipe: DatePipe) {
  }

  search(fieldName: string, value: string) {
    this.searchContract.emit([{fieldName, value}]);
  }

  toggle() {
    this.expanded = !this.expanded;
  }



  isoDateToEuro(date: string): string {
    let dateObj = new Date(date);
    if (dateObj.toString() === "Invalid Date" || dateObj.getTime() === 0) {
      return "";
    } else {
      return this.datePipe.transform(dateObj, 'dd.MM.yyyy') || "";
    }
  }

  generatePDF() {
    if (this.fnolRequest) {
      this.base64Doc = generateFnolSummaryPDF(this.fnolRequest);
    }
  }
} 
